// Polyfill process for CRA 4 + Node 24 compatibility
// CRA injects process.env.NODE_ENV via DefinePlugin, but some packages
// reference the `process` global directly at runtime which breaks in Node 24.
if (typeof process === 'undefined') {
  // eslint-disable-next-line no-global-assign
  const processPolyfill = { env: { NODE_ENV: 'production' }, platform: 'browser', browser: true }
  if (typeof window !== 'undefined') window.process = processPolyfill
  if (typeof globalThis !== 'undefined') globalThis.process = processPolyfill
} else {
  if (!process.env) process.env = {}
  if (!process.platform) process.platform = 'browser'
}

// Ensure global is defined (required by some packages)
if (typeof global === 'undefined' && typeof window !== 'undefined') {
  window.global = window
}
